import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { CustomButtonToggle } from '../../DropdownComponents';
import BaseDateRange from "../../smart/BaseDateRange";
import CustomButton from "../../CustomButton";
export default function DateDropdown (props) {
    const { t } = useTranslation('translation', { keyPrefix: 'components.dateDropdown' });
    const { start_date, end_date, id = 'date-select-dropdown', onSelectDate, limitDates, maxDate, minDate, singleDate } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState(start_date);
    const [selectedEndDate, setSelectedEndDate] = useState(end_date);

    const handleDateChange = (start, end) => {
        setSelectedStartDate(start);
        setSelectedEndDate(end);
    };

    const applyDateSelection = () => {
        onSelectDate(selectedStartDate, selectedEndDate);
        setIsOpen(false);
    };

    return (
        <Dropdown
            id={id}
            className='date-dropdown'
            role='menuitem'
            show={isOpen}
            onToggle={(isOpen) => setIsOpen(isOpen)}
            drop
        >
            <Dropdown.Toggle as={CustomButtonToggle} variant="primary">
                {start_date === end_date
                    ? moment(start_date).format('M/D/YY')
                    : (moment(start_date).format('M/D/YY') + ' - ' + moment(end_date).format('M/D/YY'))
                }
            </Dropdown.Toggle>
            <Dropdown.Menu className="date-select">
                <div className="drop-down-wrapper">
                    {isOpen 
                        ? <BaseDateRange
                            key={isOpen}
                            start_date={selectedStartDate}
                            end_date={selectedEndDate}
                            onChangeCallback={handleDateChange}
                            limitDates={limitDates}
                            maxDate={maxDate}
                            minDate={minDate}
                            singleDate={singleDate}
                        /> 
                        : ''
                    }
                    <div className="drop-down-footer">
                        <CustomButton
                            variant='primary-outline'
                            size="sm"
                            onClick={applyDateSelection}
                        >
                            {t('btnApply')}
                        </CustomButton>
                    </div>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}
